<kendo-dropdownlist [data]="users" textField="fullName" valueField="userId" [kendoDropDownFilter]="filterSettings"
  (valueChange)="valueChange($event)" [(ngModel)]="selectedUser">
  <kendo-dropdownlist-messages noDataText="{{'_No_Data_Found_Text_' | translate}}">
  </kendo-dropdownlist-messages>
</kendo-dropdownlist>
